import { Model } from 'datx';
import uuid from 'uuid/v4';

export class BaseModel extends Model {
  public static getAutoId() {
    return uuid();
  }
}
